<template>
  <div style="position: relative;">
    <modals-container name="modal1" />
    <div class="invoice_btn" @click="multinvoice" v-if="userOrders.length > 0">申请开票</div>
    <div class="task_kaoshi_list" style="padding-top: 40px;">
      <h5 class="none_ts" v-if="userOrders.length == 0" style="text-align: center;">
        <img src="@/assets/images/none_data.jpg" alt="">
        <h4>暂无订单</h4>
      </h5>
      <dl v-if="userOrders.length > 0" v-for="item in userOrders" :key="item.id">
        <dt>订单编号：{{item.orderId}}<span>{{item.payDate}}<b class="red" v-if="item.payResult=='0'">未支付</b><b v-if="item.payResult=='1'">{{item.payResultName}}</b><i class="zfb_iconfont zfb_iconfont_p" v-if="item.payMode=='1'"></i><i class="wx_iconfont wx_iconfont_p" v-if="item.payMode=='2'"></i></span></dt>
        <dd>
          <img v-if="item.payLogDetail.cover" :src="item.payLogDetail.cover" class="list_img" />
          <img v-if="(!item.payLogDetail.cover || item.payLogDetail.cover=='') && item.type=='1'" src="@/assets/images/class_img.jpg" class="list_img" />
          <img v-if="(!item.payLogDetail.cover || item.payLogDetail.cover=='') && item.type=='2'" src="@/assets/images/live_img.jpg" class="list_img" />
          <img v-if="(!item.payLogDetail.cover || item.payLogDetail.cover=='') && item.type=='3'" src="@/assets/images/class_img.jpg" class="list_img" />
          <img v-if="(!item.payLogDetail.cover || item.payLogDetail.cover=='') && item.type=='4'" src="@/assets/images/test_img.jpg" class="list_img" />
          <h3><span v-if="item.payLogDetail.id">{{item.payLogDetail.title}}</span> <span v-if="!item.payLogDetail.id">{{item.subject}}(<span style="color:red; font-size:0.8em">商品已下架</span>)</span></h3>
          <p class="man_num" v-if="item.payLogDetail.memberCnt && item.payLogDetail.memberCnt!=0"><span>{{item.payLogDetail.memberCnt}}</span>人<a v-if="item.type=='1'">已报名</a><a v-if="item.type=='2'">已学习</a><a v-if="item.type=='3'">已付费</a><a v-if="item.type=='4'">已考试</a><a v-if="item.type=='5'">已加入</a></p>
          <p class="man_num" v-if="!item.payLogDetail.memberCnt || item.payLogDetail.memberCnt==0"><span>0</span>人<a v-if="item.type=='1'">已报名</a><a v-if="item.type=='2'">已学习</a><a v-if="item.type=='3'">已付费</a><a v-if="item.type=='4'">已考试</a><a v-if="item.type=='5'">已加入</a></p>
          <p class="price_a">金额 ¥<span>{{item.money}}</span>元</p>
          <a href="javascript:;" class="go_btn" v-if="item.payResult=='1'" @click="go_detail(item.payLogDetail.id, item.type, item.businessId)">查看详情</a>
          <!--<a href="javascript:;" style="top: 85px;" class="go_btn" v-if="item.payResult=='1' && !item.invoiceId" @click="invoice(item.id)">申请开票</a>-->
          <a href="javascript:;" style="top: 85px;" class="go_btn" v-if="item.payResult=='1' && item.invoiceId" @click="getInvoice(item.invoiceId)">获取发票</a>
          <a href="javascript:;" class="go_btn" v-if="item.payResult=='0' && item.payLogDetail.id" @click="go_pay(item)">去支付</a>
          <a href="javascript:;" class="reset_btn" v-if="item.payResult=='0' && item.payLogDetail.id" @click="go_cancel(item.businessId)">取消订单</a>
        </dd>
      </dl>
    </div>
    <div v-if="userOrders.length > 0" class="zy_list_bottom mtf30">
      <dl>
        <dd>
          <paginate :click-handler="clickCallback" :page-count=pages
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text>
          </paginate>
        </dd>
      </dl>
    </div>
  </div>
</template>
<script>
import Paginate from 'vuejs-paginate'
import InvoiceBox from '@/components/byl/InvoiceBox/index.vue'
import ModalBox from '@/components/common/modal/index.vue'
import { getCookie } from '@/store/cookies.js'
export default {
  components: { Paginate },
  data () {
    return {
      orgType: null,
      originPath: window.location.href,
      filter: {
        pageNo: 1,
        pageSize: 3,
        delFlag: '0'
      },
      userOrders: [],
      orderCnt: 0,
      pages: 0,
      ori_str: ''
    }
  },
  created () {
    if (getCookie('org') && getCookie('org').businessId) { this.orgType=getCookie('org').businessId }
    this.ori_str = this.$utils.judgementOri(this.orgType)
    this.getUserOrders(this.filter).then((r) => {
      if (r.data && r.data.length>0) {
        this.orderCnt = r.cntData
        this.pages = Math.ceil(this.orderCnt / this.filter.pageSize)
        this.userOrders = r.data
      } else {
        this.orderCnt = 0
        this.pages = 0
        this.userOrders = []
      }
    })
  },
  methods: {
    clickCallback (pageNum) {
      this.filter.pageNo = pageNum
      this.getUserOrders(this.filter).then((r) => {
        if (r.data && r.data.length>0) {
          this.orderCnt = r.cntData
          this.pages = Math.ceil(this.orderCnt / this.filter.pageSize)
          this.userOrders = r.data
        } else {
          this.orderCnt = 0
          this.pages = 0
          this.userOrders = []
        }
      })
    },
    getUserOrders (filter) {
      return new Promise((resolve, reject) => {
        this.$api.post(this.$global.bylApiPath, '/payHistory/getPayHistory', filter, r => {
          resolve(r)
        })
      })
    },
    go_detail (p_id, type, b_id) {
      switch (type) {
        case '1':
          this.$router.push({path: '/' + this.ori_str + '/enroll/'+ p_id})
          break;
        case '2':
          this.$router.push({path: '/' + this.ori_str + '/livePlayDetail/'+ p_id})
          break;
        case '3':
          this.$router.push({path: '/' + this.ori_str + '/courseDetail/'+ p_id})
          break;
        case '4':
          this.$router.push({path: '/' + this.ori_str + '/examReady/'+ p_id + '/0'})
          break;
        case '5':
          this.$router.push({path: '/' + this.ori_str + '/plan/'+ p_id})
          break;
      }
    },
    go_pay (payItem) {
      if (payItem.payLogDetail) {
        var p_id = payItem.payLogDetail.id;
        var type = payItem.type;
        var b_id = payItem.businessId;
        var sign = payItem.sign;
        switch (type) {
          case '1':
            this.$router.push({path: '/'+ this.ori_str +'/enrollPay/'+ p_id + '/' + type + '/'  + b_id + '/' + this.orgType + '/' + encodeURIComponent(this.originPath) + '/' + sign})
            break;
          case '2':
            this.$router.push({path: '/'+ this.ori_str +'/livePlayPay/'+ p_id + '/' + type + '/'  + b_id + '/' + this.orgType + '/' + encodeURIComponent(this.originPath) + '/' + sign})
            break;
          case '3':
            this.$router.push({path: '/'+ this.ori_str +'/coursePay/'+ p_id + '/' + type + '/'  + b_id + '/' + this.orgType + '/' + encodeURIComponent(this.originPath) + '/' + sign})
            break;
          case '4':
            this.$router.push({path: '/'+ this.ori_str +'/examPaperPay/'+ p_id + '/' + type + '/'  + b_id + '/' + this.orgType + '/' + encodeURIComponent(this.originPath) + '/' + sign})
            break;
          case '5':
            this.$router.push({path: '/'+ this.ori_str +'/planPay/'+ p_id + '/' + type + '/'  + b_id + '/' + this.orgType + '/' + encodeURIComponent(this.originPath) + '/' + sign})
            break;
        }
      } else {
        this.$toasted.show('该订单信息不全,无法继续支付！', {
          duration: 1200
        })
      }
    },
    multinvoice (b_id) { // 批量申请开票
      var that = this
      this.getUserOrders({pageNo: 1, pageSize: 999, delFlag: '0', invoiceType: '0', payResult: '1'}).then((r) => {
        let d = []
        if (r.data && r.data.length>0) {
          d = r.data
        } else {
          d = []
        }
        this.$modal.show(ModalBox, {
          opts: {
            title: '申请开票',
            styles: {
              width: '670',
              height: String(0.785 * window.screen.availHeight)
            },
            currentComponent: {
              name: 'invoicebox',
              template: InvoiceBox,
              outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
              inputs: {
                data: d
              }
            },
            yes (val) { // 点击确认后要做的事情
              if (val.data && val.data.company && val.data.taxNo) {
                val.data.ids = val.lists
                that.$api.post(that.$global.paymentApiPath, '/invoice/saveInvoice', val.data, r => {
                  that.$toasted.show('开票成功')
                }, e => {
                  that.$toasted.show(e, {
                    duration: 1200
                  })
                })
              } else {
                that.$toasted.show('请填写公司抬头与纳税人号')
              }
            },
            closed () {}
          }
        })
      })
    },
    invoice (b_id) { // 申请开票
      var that = this
      this.$modal.show(ModalBox, {
          opts: {
            title: '申请开票',
            styles: {
              width: '670',
              height: String(0.4121 * window.screen.availHeight)
            },
            currentComponent: {
              name: 'invoicebox',
              template: InvoiceBox,
              outputsKey: 'outputs', // 该组件对外输出数据时，定义的key值
              inputs: {
                data: ''
              }
            },
            yes (val) { // 点击确认后要做的事情
              val.data.id = b_id
              that.$api.post(that.$global.paymentApiPath, '/invoice/saveInvoice', val.data, r => {
                that.getUserOrders(that.filter)
              }, e => {
                that.$toasted.show(e, {
                  duration: 1200
                })
              })
            },
            closed () { // 这里要判断, 只有新增状态下需要清空
            }
          }
        })
    },
    getInvoice (b_id) { // 获取发票
      this.$api.get(this.$global.paymentApiPath, '/invoice/getInvoiceAddress', {invoiceId: b_id}, r => {
        const a = document.createElement('a'); // 创建a标签
        a.setAttribute('download', '');// download属性
        a.setAttribute('href', r.data);// href链接
        a.setAttribute('target', '_blank'); // 打开新窗口
        a.click();// 自执行点击事件
      })
    },
    go_cancel (b_id) {
      this.$api.post(this.$global.paymentApiPath, '/paycenter/orderCancel', {businessId: b_id}, r => {
        this.getUserOrders(this.filter)
      })
    }
  }
}
</script>
<style scoped>
  .invoice_btn {
    width: 96px;
    height: 28px;
    text-align: center;
    line-height: 28px;
    color: #58acfa;
    display: block;
    border: 1px solid #58acfa;
    border-radius: 30px;
    cursor: pointer;
    position: absolute;
    left: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/page/modules/uc/order.vue